/* eslint-disable @typescript-eslint/naming-convention */
export enum operatorsEnum {
    and = 'AND',
    or = 'OR',
    not = 'NOT'
}
